module.exports = __webpack_public_path__ + "img/btn-service.8feb940.webp";